module.exports = __webpack_public_path__ + "static/law-da66fcea19af358831035018a4c337d0.png";